
import { actions } from '../../utils/constants';

const INITIAL_STATE = {
    userInfo: { photoUrl: null },
};

export default (state = INITIAL_STATE, { type, payload } ) => {
    switch (type) {

    case actions.APP_LOGOUT:
        state = INITIAL_STATE;
        return state;

    case actions.USER_INFO_FETCHED:
        return { ...state, userInfo: payload };

    default:
        return state;
    }
};



// WEBPACK FOOTER //
// ./src/components/login/login.reducer.js